<template>
  <div>
    <collapse :active-index="collapsed ? -1 : 0">
      <collapse-item>
        <h3 slot="title" class="mb-0">Información del Distribuidor</h3>

        <div>
          <div class="row">
            <div class="col-sm-6">
              <p class="h5 mb-0">Nombre</p>
              <p v-text="distributor.name"></p>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <p class="h5 mb-0">CUIT</p>
              <p v-text="distributor.cuit || '-'"></p>
            </div>
            <div class="col-sm-6">
              <p class="h5 mb-0">Asesor Técnico</p>
              <p v-if="distributor.seller">
                <router-link
                  v-if="$can('show', 'sellers')"
                  :to="{ name: 'SellerShow', params: { id: distributor.sellerId } }"
                  class="like btn-link"
                >
                  {{ distributor.seller.name }}
                </router-link>
                <span v-else v-text="distributor.seller.name"></span>
              </p>
              <p v-else>-</p>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <p class="h5 mb-0">Email</p>
              <p v-text="distributor.email"></p>
            </div>
            <div class="col-sm-6">
              <p class="h5 mb-0">Email alternativo</p>
              <p v-text="distributor.alternativeEmail || '-'"></p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <p class="h5 mb-0">Dirección</p>
              <p v-text="distributor.address"></p>
            </div>
            <div class="col-sm-6">
              <p class="h5 mb-0">Dirección depósito</p>
              <p v-text="distributor.warehouseAddress || '-'"></p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <p class="h5 mb-0">Teléfono</p>
              <p v-text="distributor.phone || '-'"></p>
            </div>
            <div v-if="distributor.city" class="col-sm-6">
              <p class="h5 mb-0">Localidad</p>
              <p v-text="`${distributor.city.name}, ${distributor.city.province.name}`"></p>
            </div>
          </div>
          <div>
            <badge class="mr-1" type="danger">
              <span class="mr-1">{{ distributor.visitsCount }}</span>
              <span v-text="distributor.visitsCount === 1 ? 'Visita' : 'Visitas'"></span>
            </badge>
            <badge class="mr-1" type="default">
              <span class="mr-1">{{ distributor.documentsCount }}</span>
              <span v-text="distributor.documentsCount === 1 ? 'Archivo' : 'Archivos'"></span>
            </badge>
            <badge class="mr-1" type="primary">
              <span class="mr-1">{{ distributor.producersCount }}</span>
              <span v-text="distributor.producersCount === 1 ? 'Prod. Asig.' : 'Prods. Asig.'"></span>
            </badge>
            <badge class="mr-1" type="info">
              <span class="mr-1">{{ distributor.plotsCount }}</span>
              <span v-text="distributor.plotsCount === 1 ? 'Lote' : 'Lotes'"></span>
            </badge>
          </div>
        </div>
      </collapse-item>
    </collapse>
  </div>
</template>

<script>
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';

export default {
  name: 'DistributorData',
  components: {
    Collapse,
    CollapseItem,
  },

  props: {
    distributor: {
      type: Object,
      required: true,
    },

    collapsed: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
